// Contextual article -> tool linking. Same intent-mapping Scout uses, applied to article bodies.
export function pickTool(article) {
  const cat = (article.category || "").toLowerCase();
  const text = `${article.title || ""} ${article.excerpt || ""} ${article.body_html || ""}`.toLowerCase();

  const parentSignals = [
    "playing time", "talk to the coach", "talk to a coach", "conversation", "conflict",
    "complain", "upset parent", "angry parent", "sideline behavior", "sideline behaviour", "car ride",
  ];

  if (cat.includes("practice") || /\b(drill|drills|practice plan|run a practice)\b/.test(text)) {
    return { name: "Practice Plan Generator", path: "/tools/practice-plan", blurb: "build a full, timed practice in seconds" };
  }
  if (parentSignals.some((s) => text.includes(s))) {
    return { name: "Parent Conversation Script Builder", path: "/tools/parent-script", blurb: "script the hard talk before it happens" };
  }
  return { name: "Coach Readiness Assessment", path: "/assessment", blurb: "see where you stand in three minutes" };
}
